/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from 'emotion-theming';

import useTranslate from 'hooks/useTranslate';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';
import { Box, Container } from '@material-ui/core';
import EmbeddedContinueButton from 'features/EmbeddedContinueButton';
import PageContainer from 'components/PageContainer';
import Button from 'components/Button';
import Link from 'components/Link';
import { contentContainer } from 'features/Theme/mixins';

import styles from './styles';
import { Theme } from 'features/Theme';

interface PropTypes {
  canRetrieveDsp: boolean;
}

const DspExpiredView: React.FC<PropTypes> = props => {
  const { canRetrieveDsp } = props;
  const t = useTranslate();
  const tMd = useMarkdownTranslate();
  const theme = useTheme<Theme>();

  return (
    <Box css={contentContainer}>
      <PageContainer>
        <Container maxWidth="sm">
          <h1 css={styles.headerTitle}>{tMd('dspExpired.title')}</h1>

          {canRetrieveDsp ? (
            <h2 css={styles.headerSubtitle}>
              {tMd('dspExpired.retrievalSubtitle')}
            </h2>
          ) : null}

          <Box my={3}>
            <p css={styles.body}>
              {canRetrieveDsp
                ? tMd('dspExpired.retrievalMessage')
                : tMd('dspExpired.expirationMessage')}
            </p>

            {(canRetrieveDsp || theme.embedded) && (
              <Box
                mt={5}
                display="flex"
                flexDirection="column"
                alignItems="center"
              >
                {canRetrieveDsp ? (
                  <Button component={Link} to="/dsp-retrieval" fullWidth>
                    {t('dspExpired.retrieveButton')}
                  </Button>
                ) : null}
                <EmbeddedContinueButton
                  variant={!canRetrieveDsp ? 'contained' : undefined}
                />
              </Box>
            )}
          </Box>
        </Container>
      </PageContainer>
    </Box>
  );
};

export default DspExpiredView;
